<!-- <app-header-pre-login></app-header-pre-login> -->
<div  *ngIf="!PageView;else other_content">
    

    <!-- New Design -->
     <div class="InCred_Outer">
        <section *ngIf="!IsMobile" class="left">
            <div class="deco-anim"></div>
            <div class="illustration">
            </div>
            <div class="BG_Img">
                <div>
                    <img src="../../assets/images/INC_Illustration.svg" class="img-fluid" alt="">
                </div>
                <p class="tagline">
                  Seamless <span class="highlight-yellow">Wealth <span class="Flow_1">fl</span><img src="../../assets/images/Money_gif.gif" width="44px" class="Flow_Gif" alt=""><span class="Flow_2">w</span></span> &amp;
                  <span class="highlight-orange">Investing<br>Experience</span> for Financial Professionals
                </p>
            </div>
          </section>
        <section class="right">
            <div class="logo">
                <img src="../../assets/images/Login_Logo.svg" alt="">
            </div>
            <div class="UnderLineTabs">
                <ul class="nav nav-tabs" id="myTab" role="tablist" [ngClass]="!IsMobile ? 'w-100':''">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link active" id="one-tab" data-toggle="tab" data-target="#one" type="button"
                            role="tab" aria-controls="one" aria-selected="true">Login</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="two-tab" data-toggle="tab" data-target="#two" type="button" role="tab"
                            aria-controls="two" aria-selected="false" disabled>
                        <span class="LinkandIcon">
                            <img src="../../assets/images/Mpin_icn.svg" class="svg Tab_Img" alt="">
                            MPIN
                        </span>
                        </button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="three-tab" data-toggle="tab" data-target="#three" type="button" role="tab"
                            aria-controls="three" aria-selected="false" disabled> <span class="LinkandIcon">
                                <img src="../../assets/images/Qr_icn.svg" class="svg Tab_Img" alt="">
                                QR Code
                                <span class="badgeCS">Coming soon</span>
                            </span>
                        </button>
                    </li>
                </ul>
            </div>
            <div class="tab-content mt-4" id="myTabContent">
                <div class="tab-pane fade show active" id="one" role="tabpanel" aria-labelledby="one-tab">
                    <div class="row">
                        <div class="col-md-12 mx-auto">
                            <div class="step-opne">
                                <form autocomplete="off" [formGroup]="LoginForm" (ngSubmit)="onSubmit()" class="LoginForm">

                                    <div class="LoginFormDefultBox UserInputContainer ">
                                        <div class="UserInputContainer">
                                            <label for="Username" class="lable">
                                                User ID
                                            </label>
                                            <input id="Username" type="text" formControlName="Username"
                                                oninput="this.value = this.value.toUpperCase()" autofocus
                                                class="form-control LoginFormInputTextBox"
                                                [ngClass]="{ 'is-invalid': LoginSubmitted && r.Username.errors }"
                                                placeholder="Enter User ID" maxlength="25" />

                                            <div *ngIf="LoginSubmitted && r.Username.errors" class="invalid-feedback">
                                                <div *ngIf="r.Username.errors.required">Please enter your User ID.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col InputBoxOuter mb-2">
                                                <div class="UserInputContainer">
                                                    <label for="Password" class="lable">
                                                        Password
                                                    </label>
                                                    <show-hide-password id="PasswordField" [btnOutline]="false"
                                                        class="Pass">
                                                        <input id="Password" type="password" formControlName="Password"
                                                            class="form-control LoginFormInputTextBox"
                                                            [ngClass]="{ 'is-invalid': LoginSubmitted && r.Password.errors }"
                                                            placeholder="Enter Password" maxlength="20" />
                                                        <div *ngIf="LoginSubmitted && r.Password.errors"
                                                            class="invalid-feedback">
                                                            <div *ngIf="r.Password.errors.required">Please enter
                                                                your
                                                                password.
                                                            </div>
                                                            <div *ngIf="r.Password.errors.pattern">Password contains
                                                                atleast 1
                                                                numeric , 1 uppercase, 1 lowercase and 1 special
                                                                character
                                                            </div>
                                                        </div>
                                                    </show-hide-password>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="destination-row">
                                            <span>Take me to</span>
                                            <select class="form-control CommonSelectBox TbxMarginBtm TakeMeTo_DDl">
                                                <option value="/dashboard" selected>Dashboard</option>
                                                <option value="/transaction-new-latest/lumpsum">Transact</option>
                                                <option value="/reports-new/dashboard">Reports</option>
                                                <option value="/explore-funds-new-latest">Explore Schemes</option>
                                            </select>
                                        </div>
                                        <button class="CommonSubmitButton mt-0 mb-4">Sign in &nbsp;→</button>
                                    </div>

                                    <div class="OtpVerificationBox d-none">
                                        <div class=" ">
                                            <div class="OtpVerificationTopGrid">
                                                <div class="TopLeftArrowImg">
                                                    <img src="../../assets/images/IIFL_New_Icons/TopLeftArrow.svg" alt="">
                                                </div>
                                                <div class="OtpVerificationTitle">
                                                    OTP Verification
                                                </div>
                                            </div>
                                            <p class="OtpVerificationParagraph">Please enter the OTP sent to your
                                                registered <br> Mobile Number <span>*****3098</span> </p>
                                        </div>
                                        <div class="row ">
                                            <div class="col InputBoxOuter">
                                                <div class=" UserInputContainer">
                                                    <div class="">
                                                        <label for="Otp" class="lable OtpText">
                                                            Enter 6 digit OTP
                                                        </label>
                                                        <ng-otp-input id="OTPBox" #ngOtpInput [config]="{
                                                                                length: 6,
                                                                                inputClass: 'OTPBox',
                                                                                allowNumbersOnly: true,
                                                                                disableAutoFocus: false,
                                                                                inputStyles: {
                                                                                'text-security': 'disc',
                                                                                '-webkit-text-security': 'disc',
                                                                                '-moz-text-security': 'disc'
                                                                                }
                                                                            }" inputmode="numeric" pattern="[0-9]*">
                                                        </ng-otp-input>
                                                        <div class="ResendText">
                                                            <span class="ResendLink"> Resent OTP in
                                                                <span id="timer">15 sec</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <button class="CommonSubmitButton  d-none">Generate OTP</button>
                                        <button class="CommonSubmitButton">Verify</button>
                                    </div>

                                    <div class="SetNewPasswordBox d-none">
                                        <div class="">
                                            <div class="OtpVerificationTopGrid">
                                                <div class="TopLeftArrowImg">
                                                    <img src="../../assets/images/IIFL_New_Icons/TopLeftArrow.svg" alt="">
                                                </div>
                                                <div class="OtpVerificationTitle SetNewPasswordtitle">
                                                    Set New Password
                                                </div>
                                            </div>
                                            <p class="OtpVerificationParagraph SetNewPasswordParagraph">Please enter
                                                a new password </p>
                                        </div>
                                        <div class="row ">
                                            <div class="col InputBoxOuter">
                                                <div class=" UserInputContainer">
                                                    <div class="">
                                                        <div class="NewPasswordBox">
                                                            <label for="NewPassword" class="lable">
                                                                New Password
                                                            </label>
                                                            <show-hide-password [btnOutline]="false" class="">
                                                                <input id="NewPassword" type="text"
                                                                    formControlName="NewPassword" autofocus
                                                                    class="form-control LoginFormInputTextBox"
                                                                    placeholder="&nbsp;" maxlength="20" />
                                                            </show-hide-password>

                                                            <div class="PasswordValidationsBox">
                                                                <div class="FirstValidation PasswordValidation">
                                                                    <div class="FirstValidationImg">
                                                                        <img src="../../assets/images/IIFL_New_Icons/PasswordValidationIcon1.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="FirstValidationText">8 - 12
                                                                        Characters</div>
                                                                </div>
                                                                <div class="SecondValidation PasswordValidation ">
                                                                    <div class="FirstValidationImg">
                                                                        <img src="../../assets/images/IIFL_New_Icons/PasswordValidationIcon1.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="FirstValidationText">Atleast 1
                                                                        Number</div>
                                                                </div>
                                                                <div class="ThirdValidation PasswordValidation ">
                                                                    <div class="FirstValidationImg">
                                                                        <img src="../../assets/images/IIFL_New_Icons/PasswordValidationIcon1.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="FirstValidationText">Do not have
                                                                        space & dots</div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div class="ConfirmPasswordBox ">
                                                            <label for="ConfirmPassword" class="lable">
                                                                Confirm Password
                                                            </label>
                                                            <show-hide-password [btnOutline]="false" class="">
                                                                <input id="NewPassword" type="text"
                                                                    formControlName="NewPassword" autofocus
                                                                    class="form-control LoginFormInputTextBox"
                                                                    placeholder="&nbsp;" maxlength="25" />
                                                            </show-hide-password>

                                                            <div class="UnMatch_Validation">Password does not match
                                                            </div>
                                                            <div class="Match_Validation">
                                                                <img src="../../assets/images/IIFL_New_Icons/GreenValidationIcon.svg"
                                                                    alt="">Password match
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="text-center">
                                            <button class="CommonSubmitButton ">New Password</button>
                                        </div>

                                    </div>

                                    <div class="ResetPasswordBox d-none">
                                        <div class="">
                                            <div class="OtpVerificationTopGrid">
                                                <div class="TopLeftArrowImg">
                                                    <img src="../../assets/images/IIFL_New_Icons/TopLeftArrow.svg" alt="">
                                                </div>
                                                <div class="OtpVerificationTitle SetNewPasswordtitle">
                                                    Reset Password
                                                </div>
                                            </div>
                                            <p class="OtpVerificationParagraph SetNewPasswordParagraph">Please enter
                                                a new password </p>
                                        </div>
                                        <div class="row ">
                                            <div class="col InputBoxOuter">
                                                <div class=" UserInputContainer">
                                                    <div class="">
                                                        <div class="NewPasswordBox">
                                                            <label for="NewPassword" class="lable">
                                                                Reset Password
                                                            </label>
                                                            <show-hide-password [btnOutline]="false" class="">
                                                                <input id="NewPassword" type="text"
                                                                    formControlName="NewPassword" autofocus
                                                                    class="form-control LoginFormInputTextBox"
                                                                    placeholder="&nbsp;" maxlength="25" />
                                                            </show-hide-password>

                                                            <div class="PasswordValidationsBox">
                                                                <div class="FirstValidation PasswordValidation">
                                                                    <div class="FirstValidationImg">
                                                                        <img src="../../assets/images/IIFL_New_Icons/PasswordValidationIcon1.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="FirstValidationText">8 - 12
                                                                        Characters</div>
                                                                </div>
                                                                <div class="SecondValidation PasswordValidation ">
                                                                    <div class="FirstValidationImg">
                                                                        <img src="../../assets/images/IIFL_New_Icons/PasswordValidationIcon1.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="FirstValidationText">Atleast 1
                                                                        Number</div>
                                                                </div>
                                                                <div class="ThirdValidation PasswordValidation ">
                                                                    <div class="FirstValidationImg">
                                                                        <img src="../../assets/images/IIFL_New_Icons/PasswordValidationIcon1.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="FirstValidationText">Do not have
                                                                        space & dots</div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div class="ConfirmPasswordBox ">
                                                            <label for="ConfirmPassword" class="lable">
                                                                Confirm Password
                                                            </label>
                                                            <show-hide-password [btnOutline]="false" class="">
                                                                <input id="NewPassword" type="text"
                                                                    formControlName="NewPassword" autofocus
                                                                    class="form-control LoginFormInputTextBox"
                                                                    placeholder="&nbsp;" maxlength="25" />
                                                            </show-hide-password>

                                                            <div class="UnMatch_Validation">Password does not match
                                                            </div>
                                                            <div class="Match_Validation">
                                                                <img src="../../assets/images/IIFL_New_Icons/GreenValidationIcon.svg"
                                                                    alt="">Password match
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="text-center w-100">
                                            <button class="CommonSubmitButton ">Reset Password</button>
                                        </div>
                                    </div>

                                    <div class="PasswordSetSuccessfullyGreetingBox d-none">
                                        <div class="row ">
                                            <div class="col InputBoxOuter">

                                                <div class=" UserInputContainer">
                                                    <div class="">
                                                        <div class="GreetingBox">

                                                            <div class="GreetingImg">
                                                                <img src="../../assets/images/IIFL_New_Icons/PasswordSetSuccessIcon.svg"
                                                                    alt="">
                                                            </div>

                                                            <div class="GreetingText">
                                                                Your password <br> has been set successfully!
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="text-center w-100 mb-5">
                                            <button class="CommonSubmitButton PasswordSetSuccessGreetingBtn ">Login</button>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                
                

            </div>

            <button class="btn-google">
                <!-- Google G SVG -->
                <svg class="g-icon" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"
                        fill="#4285F4" />
                    <path
                        d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"
                        fill="#34A853" />
                    <path
                        d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"
                        fill="#FBBC05" />
                    <path
                        d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"
                        fill="#EA4335" />
                </svg>
                Sign in
            </button>
            <!-- <div class="d-flex justify-content-between align-items-center mt-2">
                <span routerLink="/cp-forgot-password" routerLinkActive="active" class="ForgetPassLink " (click)="SendUserType()">
                    Forgot User ID?
                </span>
                <span routerLink="/cp-forgot-password" routerLinkActive="active" class="ForgetPassLink" (click)="SendUserType()">
                    Forgot Password?
                </span>
            </div> -->

             <div class="footer-links" [ngClass]="!IsMobile ? 'mt-5':'mt-3'">
                <a href="/franchise-onboarding" >BP Onboarding</a>
                <span>|</span>
                <a href="/disclaimer">Disclaimer</a>
                 <span>|</span>
                <!-- <a >Privacy Policy</a> 
                <span>|</span> -->
                <a href="/terms-and-conditions">T&Cs</a>
                <span>|</span>
                <a href="/about-us">About Us</a>
            </div>
            <p class="powered">Powered by <span>InCred Markets</span></p>
        </section>
    </div>
    <!-- New Design Ends -->
    

    
    <app-footer></app-footer>
</div>

<ng-template #other_content>
    <div></div>
</ng-template>